var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "submitterdetail_container"
  }, [_vm.submitterData ? _c('div', {
    staticClass: "submiterDetail_wrapper d-flex gap-4 flex-wrap"
  }, [_vm._m(0), _c('div', {
    staticClass: "submitterDetails_content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center submitterDetails_name gap-3 mb-2 flex-wrap"
  }, [_c('h3', {
    staticClass: "clr-title fw-bold mb-0"
  }, [_vm._v(" " + _vm._s(_vm.submitterData.fullname || "".concat(_vm.submitterData.first_name, " ").concat(_vm.submitterData.last_name) || 'N/A') + " ")]), _c('span', {
    staticClass: "submitterDetails_grouptype clr-primary font-12"
  }, [_vm._v(" " + _vm._s(_vm.submitterData.user_type || 'N/A') + " ")])]), _c('div', {
    staticClass: "submitterDetails_infowrapper d-flex flex-column gap-1"
  }, [_c('div', {
    staticClass: "submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap"
  }, [_vm.submitterData.email ? [_c('a', {
    staticClass: "user_email text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type",
    attrs: {
      "href": "`mailto:${submitterData.email}`"
    }
  }, [_c('span', {
    staticClass: "icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm8-7L4 8v10h16V8zm0-2l8-5H4zM4 8V6v12z"
    }
  })])]), _vm._v(" " + _vm._s(_vm.submitterData.email || 'N/A') + " ")])] : _vm._e(), _c('span', {
    staticClass: "dots"
  }), [_c('a', {
    staticClass: "user_phonenumber text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type",
    attrs: {
      "href": "`tel:${submitterData.phone}`"
    }
  }, [_c('span', {
    staticClass: "icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M8.172 15.829c3.845 3.845 7.408 4.266 8.454 4.305c1.264.046 2.554-.986 3.112-2.043c-.89-1.044-2.049-1.854-3.318-2.732c-.749.748-1.672 2.138-2.901 1.64c-.699-.281-2.425-1.076-3.933-2.585S7.283 11.18 7 10.482c-.498-1.231.896-2.156 1.645-2.905c-.878-1.29-1.674-2.479-2.716-3.324c-1.072.56-2.11 1.84-2.063 3.121c.039 1.046.46 4.609 4.306 8.455m8.38 6.304c-1.44-.053-5.521-.617-9.795-4.89c-4.273-4.274-4.836-8.354-4.89-9.795c-.08-2.196 1.602-4.329 3.545-5.162a1.47 1.47 0 0 1 1.445.159c1.608 1.173 2.717 2.95 3.67 4.342A1.504 1.504 0 0 1 10.35 8.7l-1.356 1.357C9.309 10.752 9.95 11.95 11 13s2.248 1.691 2.944 2.006l1.355-1.356a1.5 1.5 0 0 1 1.918-.171c1.42.984 3.088 2.077 4.304 3.634a1.47 1.47 0 0 1 .189 1.485c-.837 1.953-2.955 3.616-5.158 3.535"
    }
  })])])]), _vm._v(" " + _vm._s(_vm.submitterData.phone || 'N/A') + " ")])]], 2), _c('div', {
    staticClass: "submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap"
  }, [_c('div', {
    staticClass: "clr-title"
  }, [_vm._v(" Created On : "), _c('span', {
    staticClass: "clr-bold-grey"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.submitterData.created_at)))])])]), _c('div', {
    staticClass: "submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap"
  }, [_c('div', {
    staticClass: "clr-title"
  }, [_vm._v(" Device : "), _c('span', {
    staticClass: "clr-bold-grey"
  }, [_vm._v(_vm._s(_vm.submitterData.device || 'N/A'))])]), _c('span', {
    staticClass: "dots"
  }), _c('div', {
    staticClass: "clr-title"
  }, [_vm._v(" Last Login IP : "), _c('span', {
    staticClass: "clr-bold-grey"
  }, [_vm._v(_vm._s(_vm.submitterData.last_login_ip || 'N/A'))])])])])])]) : _c('div', {
    staticClass: "text-center p-4"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Loading submitter details...")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "submitterDetails_avatar"
  }, [_c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": require("../../../assets/images/user.svg")
    }
  })]);
}]

export { render, staticRenderFns }